import { Button } from '@lemonade-hq/nuis';
import styled from 'styled-components';
import { themedColor } from '@lemonade-hq/cdk';
import React from 'react';

const Giveback2021SpecialButton = styled(Button)<{ shown?: boolean }>`
  height: 36px;
  padding: 0;
  border-radius: 60px;
  border: none;
  transition: transform 500ms cubic-bezier(0.34, 1.56, 0.64, 1);
  transform: translateY(${({ shown }: { shown?: boolean }) => (shown ? '0' : '200px')});
  background-color: ${themedColor('night')} !important;
  color: white !important;
  box-shadow: 0 3px 10px rgb(0 0 0 / 15%);

  &:hover,
  &:active {
    background-color: ${themedColor('darkNight')} !important;
  }
`;

export default React.memo(Giveback2021SpecialButton);
